export function ProductURLBuilder(
  name: string | undefined,
  gender: string | undefined,
  slug: string,
  type: 1 | 2,
) {
  gender = gender ?? ''
  name = name ?? ''
  if (type == 1) {
    return '/product/' + slug + '?name=' + name + '&gender=' + gender
  } else {
    return '/product/notebook/' + slug + '?name=' + name + '&gender=' + gender
  }
}
export function PersonalizeURLBuilder(
  inputs: any,
  gender: string | undefined = undefined,
  slug: string,
  dedication: string | undefined = '',
  cover: string | undefined = '',
  is_edit: string | undefined = '',
  uuid: string | undefined = '',
) {
  gender = gender ?? ''

  inputs = JSON.stringify(inputs)
  const params = new URLSearchParams({
    inputs,
    gender,
    cover,
    dedication,
    is_edit,
    uuid,
  })

  return '/personalize/' + slug + '?' + params.toString()
}
